import { getItemClientId } from 'owa-mail-list-table-operations/lib/actions/store-factory/mapItemTypeToItemRelation';
import getItemForMailList from 'owa-mail-store/lib/selectors/getItemForMailList';
import { isFirstLevelExpanded } from 'owa-mail-list-store/lib/selectors/isConversationExpanded';
import type { TableView } from 'owa-mail-list-store';
import type { ClientItemId } from 'owa-client-ids';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';

export default function getExpandedItemId(tableView: TableView, nodeIds: string[]): ClientItemId {
    const rowKey = [...tableView.selectedRowKeys.keys()][0];
    const expandedFirstLevel = isFirstLevelExpanded(rowKey);
    const item: ClientItem | null | undefined = getItemForMailList(nodeIds[0], expandedFirstLevel);
    const clientItemId = getItemClientId(item, tableView);
    return clientItemId;
}
